import { StatusBar } from 'expo-status-bar';
import React from 'react';
import ENV from 'app/utils/ENV'
import { StyleSheet, View, ScrollView, TouchableOpacity, ActivityIndicator, 
  TextInput, UIManager, Platform, RefreshControl, } from 'react-native';
import Animated from 'react-native-reanimated'
const { multiply, sub } = Animated;
import Text from 'app/components/Text'
import * as RootNavigation from 'app/utils/RootNavigation.js';
import { styleSheet, colors, sizes, WIDTH } from 'app/utils/styleSheet'
import { Ionicons, Entypo, Feather, } from '@expo/vector-icons';
import storageActions from 'app/utils/storageActions'
import prefActions from 'app/utils/prefActions'
import valueActions from 'app/utils/valueActions'
import valueHelpers from 'app/utils/valueHelpers'
import filterHelpers from 'app/utils/filterHelpers'
import store from 'app/redux/store'

import FilterBar from 'app/components/FilterBar'
import PaginatedList from 'app/components/PaginatedList'

export default class ListView extends React.Component { 
  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation

    let { navigation, route, } = this.props

    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons name="ios-menu" size={32} color="white" style={{marginRight: 20}} />
        </TouchableOpacity>
      ),
    })
    
    let { ids, level, } = !!route && route.params ? route.params : {}
    if(!!ids){
      if(typeof ids == 'string'){
        ids = [ids] // single id comes in as a string rather than array
      }
      ids = ids.map(id => parseInt(id))
    }
    else {
      ids = []
    }

    let { app, preferences, values, } = store.getState()
    
    // values = filterHelpers.apply(values)
    // let levelIds = valueHelpers.getLevelIds(values)
    // values = valueHelpers.filterToCurrentRevisions(values)
    // values = valueHelpers.sortByProgress(values, levelIds)
    // let topLevel = valueHelpers.getTopLevel(levelIds)
    values = []
    let levelIds = {}
    let topLevel = undefined

    this.state = {
      ids,
      values,
      levelIds,
      topLevel,
      loading: app.loading,
      refreshing: false,
      level: level || 0,
      scale: 1.0,
    }
  }

  async componentDidMount(){
    this.unsubscribe = store.subscribe(() => {
      let { app, values, } = store.getState()
      values = filterHelpers.apply(values)
      let levelIds = valueHelpers.getLevelIds(values)
      values = valueHelpers.filterToCurrentRevisions(values)
      values = valueHelpers.sortByProgress(values, levelIds)
      let topLevel = valueHelpers.getTopLevel(levelIds)
      this.setState({
        values,
        levelIds,
        topLevel,
        loading: app.loading,
      })

    })
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render(){
    let { ids, values, loading, level, levelIds, topLevel,
      refreshing, scale, } = this.state

    // let allValuesTopLevel = valueHelpers.topLevel(allValues)

    // let topLevel = valueHelpers.getTopLevel(values)

    return (
      <View style={styles.wrapper}>

        <FilterBar
          hideQuery
          levelButtons
          onUpdate={() => {
            console.log('on update filters')
            this.setState({filterKey: (this.state.filterKey || 0)+1})
          }}
          onUpdateFilter={(filter, val) => {
            // return
            if(filter == 'level'){
              this.setState({level: val})
              // console.log(this.list)
              console.log('updating level', level)
              this.list && this.list.scrollToLevel(val)
            }
          }}
          topLevel={topLevel}
          level={level}
          scale={scale}
          onUpdateScale={scale => this.setState({scale})}
        />

        <PaginatedList 
          values={values}
          loading={loading}
          levelIds={levelIds}
          topLevel={topLevel}
          ids={ids}
          ref={ref => this.list = ref}
          allValues={values}
          //allValuesTopLevel={allValuesTopLevel}
          topLevel={topLevel}
          level={level}
          noDrag
          onRefresh={() => {
            this.setState({refreshing: true})
            this.fetch()
          }}
          refreshing={refreshing}
          hideButtons
          // onSubmit={(value) => RootNavigation.push('Value', {value, id: value.id})}
          onSubmit={(value) => RootNavigation.push('List', {ids: [value.id]})}
          onChangeLevel={lvl => {
            // return
            // delay
            if(this.levelScrollTimeout) clearTimeout(this.levelScrollTimeout)
            this.levelScrollTimeout = setTimeout(() => {
              console.log('updating level from level scroll')
              this.setState({level: lvl})
            }, 300)
          }}
          onUpdate={this.handleUpdate}
          scale={scale}
        />
      </View>
    )
  }

  handleUpdate = async (val, newPrefs=null) => {
    alert('update? nah')
    return
    let allValues = this.state.allValues.map(v => v.id == val.id ? {...v, ...val} : v)
    allValues = valueHelpers.sortByTimeline(allValues)
    storageActions.saveItem('values', allValues)
    allValues = valueHelpers.onlyRecentRevisions(allValues)

    // console.log('handleupdate:', val, newPrefs)
    // if(!!newPrefs){
    //   this.setState({...newPrefs})
    // }
    let pref = await prefActions.get(true)
    await this.setState({
      hiddenIds: pref.hidden_ids, 
      todoIds: pref.todo_ids, 
      focusIds: pref.focus_ids, 
      filters: pref.filters, 
    })
    await this.setState({allValues})
  }

}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    // flexDirection: 'row',
    // justifyContent: 'center',
    // alignItems: 'flex-start'
    alignSelf: 'center',
    width: '100%',
    maxWidth: 500,
  },
  headerRow: {
    padding: sizes.base,
    borderBottomWidth: 1,
    borderColor: colors.trim,
  },
  row: {
    zIndex: -1,
    flex: -1,
    flexDirection: 'row',
    alignSelf: 'stretch',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  iconWrapper: {
    flexDirection: 'row',
    marginLeft: sizes.base,
  },
  icon: {
    marginLeft: sizes.base,
    fontSize: sizes.large,
    width: sizes.large,
  },
})